import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/addresses-modal.actions';
import { DeliveryTypeEnum } from '../networking/models/location/enum/delivery-type.enum';

export const initialState: actions.AddressModalInterface = {
  addresses: [],
  city: null,
  tags: null,
  geopos: null,
  address: null,
  loading: false,
  comments: null,
  nickname: null,
  editMode: false,
  openModal: false,
  reposition: false,
  errorLoadList: false,
  addAfterEdit: false,
  deliveryTypeText: null,
};

export const _addressesModalReducer = createReducer(
  initialState,
  on(actions.create, (state, {address}) => {
    return state.editMode ? { ...state } : { ...state, address};
  }),
  on(actions.add, (state, {address}) => {
    const addresses = [...state.addresses, address];
    return {...state, addresses};
  }),
  on(actions.update, (state, {address}) => {
    const addresses = state.addresses.map(
      (addressItem) => (addressItem.idAddress == address.idAddress) ? {...address} : addressItem);
    return {...state, loading: false, addresses};
  }),
  on(actions.remove, (state, {idAddress}) => {
    const addresses = state.addresses.filter(address => address.idAddress != Number(idAddress));
    return {...state, loading:false, addresses};
  }),
  on(actions.removeAll , (state) => ({...state, addresses: []})),
  on(actions.reset , (state) => ({...initialState, addresses: state.addresses})),
  on(actions.clear , (state) => ({...state, editMode: false, address: null, city: null})),
  on(actions.editAddress , (state, {address, city}) => ({...state, address, editMode: true, city: {...city}})),
  on(actions.setCustomerAddress , (state, {addresses}) => ({...state, loading:false, addresses})),
  on(actions.setLoading, (states, {loading}) => ({...states, errorLoadList: false, loading}) ),
  on(actions.setPosition,(state, {geopos}) => ({...state, geopos})),
  on(actions.reposition, (state, {sw}) => ({...state, reposition: sw})),
  on(actions.addAfterEdit, (state) => ({...state, addAfterEdit: true}) ),
  on(actions.openModal, (state, {open}) => {
    const newState = ({...initialState, geopos: state.geopos,addresses: state.addresses, openModal: open});
    if(!open) { newState.loading = false; newState.addAfterEdit =  false;}
    else { newState.loading = state.loading; newState.addAfterEdit = state.addAfterEdit;}
    return newState;
  }),
  on(actions.setAddress, (state, {address}) => {
    const nAddress = {...state.address, ...address};
    const reposition = (state.city.deliveryType !== DeliveryTypeEnum.ENVIALOYA);
    return {...state, loading: false, reposition, address: nAddress}
  }),
  on(actions.setAddressMarker, (state, {address, city}) => {
    return {...state, loading: false, city, address: {...state.address, ...address}}
  }),
  on(actions.setActualPosition, (state, {geopos}) => {
    const address = {...state.address, latitude: geopos.lat, longitude: geopos.lng};
    return {...state, reposition: true, geopos, address};
  }),
  on(actions.errorLoadList, (state, {sw}) => ({...state, errorLoadList: sw})),
  on(actions.setCity, (state, {city}) => {
    if(city) {
      const address = {
        ...state.address,
        city: city.id,
        deliveryType: city.deliveryType,
        defaultStore: city.defaultStore
      };
      if(address.cityName !== city.name) {
        address.latitude  = city.latitude;
        address.longitude = city.longitude;
      }
      if(!state.editMode) { address.address = null; }
      return {...state, reposition: true, city: {...city}, address};
    }
    else {
      return {...state, reposition: false, city: null, address: null};
    }
  }),
  on(actions.setPrediction, (state, {prediction}: any) => {
    const address = {...state.address,address: prediction.description}
    if(prediction.latitude)  address.latitude = prediction.latitude;
    if(prediction.longitude) address.longitude= prediction.longitude;
    return {...state, reposition: true, address};
  }),
);

export function addressesModalReducer(state, action) : actions.AddressModalInterface {
  return _addressesModalReducer(state, action);
}